import React from 'react'
//Icons
import { BiHomeAlt, BiUser } from 'react-icons/bi'
import { BsClipboardData, BsBriefcase, BsChatSquare } from 'react-icons/bs'
//Link
import { Link } from 'react-scroll'

const Nav = () => {
  return (
    <nav className="fixed bottom-2 lg:bottom-8 w-full overflow-hidden z-50">
      <div className="container mx-auto">
        {/* Inner Nav */}
        <div className="w-full bg-black/20 h-[96px] backdrop-blur-2xl rounded-full flex max-w-[460px] mx-auto px-5 items-center justify-between text-2xl text-white/50 focus:text-red-500">
          <Link
            activeClass="active"
            smooth={true}
            offset={-200}
            to="home"
            className="hover:bg-black hover:rounded-full hover:transition-all duration-[200px] flex items-center justify-center w-[60px] h-[60px] cursor-pointer"
          >
            <BiHomeAlt />
          </Link>
          <Link
            activeClass="active"
            smooth={true}
            to="about"
            className="hover:bg-black hover:rounded-full hover:transition-all duration-[200px] flex items-center justify-center w-[60px] h-[60px] cursor-pointer"
          >
            <BiUser />
          </Link>
          <Link
            activeClass="active"
            smooth={true}
            to="services"
            className="hover:bg-black hover:rounded-full hover:transition-all duration-[200px] flex items-center justify-center w-[60px] h-[60px] cursor-pointer"
          >
            <BsClipboardData />
          </Link>
          <Link
            activeClass="active"
            smooth={true}
            to="work"
            className="hover:bg-black hover:rounded-full hover:transition-all duration-[200px] flex items-center justify-center w-[60px] h-[60px] cursor-pointer"
          >
            <BsBriefcase />
          </Link>
          <Link
            activeClass="active"
            smooth={true}
            to="contact"
            className="hover:bg-black/20 hover:rounded-full hover:transition-all duration-[200px] flex items-center justify-center w-[60px] h-[60px] cursor-pointer"
          >
            <BsChatSquare />
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Nav
